module.exports = "//d274d294w9cx2v.cloudfront.net/60b2874f492af1d98de2e04cd944e9186b005508/images/payPalBadge.png";